<template>
  <ul class="three-col-table-list-fully-stack">
    <div v-for="sub in subscriptions" :key="sub.id">
      <SubscriptionListItem
        :subscription="sub"
        :user="user"
        :bundles="bundles"
        :subscriptionIds="subscriptionIds"
      />
    </div>
    <li v-if="user.consulting_access">
      <span>Consulting</span>
      <span><strong>Enabled</strong></span>
      <span>
        <a class="button-green" href="/consulting">View</a>
        <a class="button-grey" href="/dashboard/unsubscribe/consulting">
          Unsubscribe
        </a>
      </span>
    </li>
  </ul>
</template>

<script>
  import SubscriptionListItem from '~/components/dashboard/subscriptions/SubscriptionListItem.vue';

  export default {
    components: {
      SubscriptionListItem,
    },
    props: {
      subscriptions: {
        type: [Array, Object],
        required: true,
      },
      user: {
        type: Object,
        required: true,
      },
      bundles: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        today: new Date(),
      };
    },
    computed: {
      subscriptionIds() {
        return Object.values(this.subscriptions).map(
          (subscription) => subscription.product.id
        );
      },
    },
  };
</script>

<style scoped>
  /* Add your component-specific styles here */
</style>
